<footer class="dominionFooter" >
  <nav class="float-left">
    <ul>
      <li class="footerLinks">
        <a href="https://www.dominion-global.com/es/transformacion-digital/lynx" target="_blank">
          {{ 'FOOTER.ABOUT_US'  | translate}}
        </a>
      </li>
      <li class="footerLinks">
        <a href="https://www.dominion-global.com/es/areas-de-actividad" target="_blank">
          {{ 'FOOTER.ACTIVITY_AREAS'  | translate}}
        </a>
      </li>
      <li class="footerLinks">
        <a href="https://www.dominion-global.com/es/contacto" target="_blank">
          {{ 'FOOTER.CONTACT'  | translate}}
        </a>
      </li>
    </ul>
  </nav>
  <div class="copyright footer">
    &copy;
    2022
      , a Global Dominion Access product.
  </div>
</footer>